<mat-dialog-content class="mat-typography">
    <div class="loading" *ngIf="loading">
        <mat-spinner diameter="20"></mat-spinner>
        Please wait...
    </div>
    <ng-container *ngIf="currentVariation>-1">
        <img [src]="variations[currentVariation].secure_url" width="512" height="512" alt="Generated Image" class="generated-image" />
    </ng-container>
</mat-dialog-content>
<mat-dialog-actions>
    <mat-paginator *ngIf="!loading && variations.length > 1" pageSize="1" [length]="variations.length" (page)="selectVariation($event)" showFirstLastButtons="false" firstPageLabel="" itemsPerPageLabel="Choose variation" [pageIndex]="currentVariation" hidePageSize="true">
    </mat-paginator>
    <div style="flex:1"></div>
    <button mat-button color="lightGreen" (click)="accept()" *ngIf="!loading">Accept</button>
    <button mat-button color="blueBayouxDark" (click)="regenerate()" *ngIf="!loading">Regenerate</button>
    <button mat-button color="warn" (click)="reject()" *ngIf="!loading">Reject</button>
    <button mat-button color="fiord" (click)="cancel()" *ngIf="loading">Cancel</button>
</mat-dialog-actions>